module.exports = "/images/Jet_v2.svg?557354eaeb858d1af2c208c36952d739";